export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40ee6336f204f84f6bd113e97759c1095d3cff4f24&name=revalidateCommunity!'